<div class="home">
  <section class="hero" aria-labelledby="home-title">
    <div class="hero-copy">
      <h1 id="home-title">Web y software para empresas, claro desde el principio.</h1>
      <p class="hero-lead">
        Creamos y actualizamos la presencia online de medianas empresas, además de desarrollar
        programas internos que ordenan su gestión. Trabajamos en toda España con alcance acordado y
        precio cerrado desde el inicio.
      </p>
      <div class="hero-actions">
        <a class="button button-primary" routerLink="/contacto">Cuéntanos tu proyecto</a>
        <a class="button button-secondary" routerLink="/servicios">Ver servicios</a>
      </div>
      <ul class="service-summary" aria-label="Servicios principales">
        <li>Desarrollo web</li>
        <li>Soluciones a medida</li>
        <li>Mantenimiento</li>
        <li>Hosting y dominios</li>
      </ul>
    </div>

    <app-home-visual />
  </section>

  <section class="section problems" aria-labelledby="problems-title">
    <div class="section-heading">
      <h2 id="problems-title">La tecnología no debería complicar más tu negocio.</h2>
      <p>
        Una solución digital útil empieza por entender qué necesita la empresa y explicarlo sin
        rodeos.
      </p>
    </div>
    <ul class="problem-list">
      <li>
        <span>01</span>
        <h3>Una web que ya no representa al negocio</h3>
        <p>Cuando la presencia digital se ha quedado atrás, también puede hacerlo la confianza.</p>
      </li>
      <li>
        <span>02</span>
        <h3>Procesos manuales que consumen tiempo</h3>
        <p>
          Aplicaciones e integraciones pueden ordenar tareas que hoy dependen de pasos repetidos.
        </p>
      </li>
      <li>
        <span>03</span>
        <h3>Decisiones técnicas difíciles de valorar</h3>
        <p>Traducimos cada propuesta a objetivos, alcance y próximos pasos comprensibles.</p>
      </li>
    </ul>
  </section>

  <section class="section services" aria-labelledby="services-title">
    <div class="section-heading">
      <h2 id="services-title">Soluciones digitales con una función concreta.</h2>
    </div>
    <div class="service-grid">
      <article>
        <span class="service-number">01</span>
        <h3>Desarrollo web</h3>
        <p>Webs profesionales para presentar el negocio con claridad y facilitar el contacto.</p>
        <a routerLink="/servicios/desarrollo-web">Conocer el servicio de desarrollo web</a>
      </article>
      <article>
        <span class="service-number">02</span>
        <h3>Desarrollo personalizado</h3>
        <p>Aplicaciones, integraciones y herramientas adaptadas a necesidades específicas.</p>
        <a routerLink="/servicios/desarrollo-personalizado">Conocer el desarrollo personalizado</a>
      </article>
      <article>
        <span class="service-number">03</span>
        <h3>Mantenimiento web</h3>
        <p>Soporte para conservar una web estable, actualizada y alineada con el negocio.</p>
        <a routerLink="/servicios/mantenimiento">Conocer el servicio de mantenimiento</a>
      </article>
      <article>
        <span class="service-number">04</span>
        <h3>Hosting y dominios</h3>
        <p>Gestión del alojamiento y el dominio asociados al desarrollo de la web.</p>
        <a routerLink="/servicios/hosting-y-dominios">Conocer el servicio de hosting y dominios</a>
      </article>
    </div>
  </section>

  <section class="local-service" aria-labelledby="local-service-title">
    <div>
      <p class="eyebrow">Desarrollo web en Segovia</p>
      <h2 id="local-service-title">Un estudio cercano para pymes y negocios locales.</h2>
    </div>
    <div>
      <p>
        Trabajamos desde Segovia creando páginas web profesionales para empresas de la zona y
        proyectos de toda España. Combinamos cercanía, claridad y una base técnica preparada para
        crecer.
      </p>
      <a class="text-link" routerLink="/desarrollo-web-segovia">
        Conoce el servicio de desarrollo web en Segovia
      </a>
    </div>
  </section>

  <section class="section value" aria-labelledby="value-title">
    <div>
      <h2 id="value-title">Complejidad por dentro. Claridad por fuera.</h2>
    </div>
    <ul>
      <li>
        <strong>Decisiones explicadas</strong>
        <span>Información comprensible para saber qué se plantea y por qué.</span>
      </li>
      <li>
        <strong>Alcance ordenado</strong>
        <span>Prioridades claras para centrar el proyecto en lo que aporta valor.</span>
      </li>
      <li>
        <strong>Soluciones proporcionadas</strong>
        <span>Tecnología ajustada a la necesidad real, sin complejidad gratuita.</span>
      </li>
    </ul>
  </section>

  <section class="section process" aria-labelledby="process-title">
    <div class="section-heading">
      <h2 id="process-title">Un proyecto entendible de principio a fin.</h2>
      <p>La conversación comienza por el problema del negocio, no por la tecnología.</p>
    </div>
    <ol>
      <li>
        <span>01</span>
        <div>
          <h3>Entender</h3>
          <p>Partimos del contexto, los objetivos y las necesidades reales de la empresa.</p>
        </div>
      </li>
      <li>
        <span>02</span>
        <div>
          <h3>Ordenar</h3>
          <p>Definimos una solución y un alcance que se puedan valorar con claridad.</p>
        </div>
      </li>
      <li>
        <span>03</span>
        <div>
          <h3>Construir</h3>
          <p>Desarrollamos la solución cuidando utilidad, accesibilidad y rendimiento.</p>
        </div>
      </li>
    </ol>
    <a class="text-link" routerLink="/como-trabajamos">Conoce cómo trabajamos</a>
  </section>

  <section class="section faq" aria-labelledby="faq-title">
    <div class="section-heading">
      <h2 id="faq-title">Antes de hablar de tu proyecto.</h2>
    </div>
    <div class="faq-list">
      <details>
        <summary>¿Qué necesito tener preparado antes de empezar?</summary>
        <p>
          No necesitas tenerlo todo cerrado desde el primer día. Empezamos con una reunión breve
          para entender tu negocio, tus objetivos y el tipo de web que necesitas. A partir de ahí,
          definimos el alcance, la estructura, los contenidos y los recursos necesarios. Si todavía
          no tienes textos, imágenes o una identidad visual clara, también podemos ayudarte a
          prepararlos dentro del presupuesto.
        </p>
      </details>
      <details>
        <summary>¿Qué tipo de proyectos podéis desarrollar?</summary>
        <p>
          Webs profesionales, desarrollos personalizados, aplicaciones, integraciones y herramientas
          internas para empresas.
        </p>
      </details>
      <details>
        <summary>¿También ofrecéis mantenimiento?</summary>
        <p>
          Sí. El mantenimiento web forma parte de los servicios y su alcance se define según las
          necesidades de cada proyecto.
        </p>
      </details>
      <details>
        <summary>¿Cómo se prepara un presupuesto?</summary>
        <p>
          Primero analizamos qué necesita realmente tu negocio, cuáles son los objetivos de la web y
          qué funcionalidades son necesarias para alcanzarlos. Con esa información definimos un
          alcance claro y preparamos un presupuesto ajustado al proyecto. No añadimos servicios,
          páginas o integraciones que no aporten valor ni presupuestamos elementos “por si acaso”.
          La propuesta incluye únicamente lo necesario para conseguir un resultado profesional, útil
          y preparado para crecer cuando el negocio lo necesite.
        </p>
      </details>
    </div>
  </section>

  <section class="final-cta" aria-labelledby="cta-title">
    <h2 id="cta-title">Cuéntanos qué necesita tu empresa.</h2>
    <p>Explícanos tu idea, el problema que quieres resolver o el punto en el que estás.</p>
    <a class="button button-primary" routerLink="/contacto">Empezar una conversación</a>
  </section>
</div>
